<template>
  <span class="status-pill" :data-status="statusKey">{{ label }}</span>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  value: {
    type: String,
    default: '',
  },
})

const labels = {
  not_started: 'Not started',
  in_progress: 'In progress',
  submitted: 'Submitted',
  reviewed: 'Reviewed',
  active: 'Active',
  published: 'Published',
  inactive: 'Inactive',
  archived: 'Archived',
}

const statusKey = computed(() => props.value || 'unknown')
const label = computed(() => labels[props.value] || props.value || 'Unknown')
</script>

<style scoped>
.status-pill {
  display: inline-flex;
  align-items: center;
  min-height: 1.75rem;
  border-radius: 999px;
  padding: 0.125rem 0.625rem;
  background: var(--surface-muted);
  color: var(--ink-muted);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  line-height: 1.2;
}

[data-status='not_started'],
[data-status='inactive'],
[data-status='archived'] {
  background: var(--status-not-started-bg);
  color: var(--status-not-started-fg);
}

[data-status='in_progress'],
[data-status='active'] {
  background: var(--status-in-progress-bg);
  color: var(--status-in-progress-fg);
}

[data-status='submitted'],
[data-status='published'] {
  background: var(--status-submitted-bg);
  color: var(--status-submitted-fg);
}

[data-status='reviewed'] {
  background: var(--status-reviewed-bg);
  color: var(--status-reviewed-fg);
}
</style>
